
export enum AARouterURL {
  // main routes
  ROUTE_PLANNER = 'route',
  TRAFFIC_NEWS = 'traffic-news',
  MAP_HOTELS = 'maps-hotels',
  MAP_PRINT_PREVIEW = 'map-print-preview',
  MAP_PRINT_PREVIEW_CLOSE = 'map_print-preview-close',

  PRINT_PREVIEW = 'print-preview',
  PRINT_PREVIEW_CLOSE = 'print-preview-close',

  MILEAGE_CALCULATOR = 'mileage-calculator',
  WALKS_BIKES = 'walks-bikes',

  // outlets
  OUTLET_PRINT = 'modal',

  // mobile child view
  MOBILE_MAP = 'map',

  // params
  _FROM = 'from',
  _TO = 'to',
  _VIA = 'via',
  _OPTIONS = 'options',
  _LOCATION = 'location',
  _SEPARATOR = '|',
  _FROM_PLACE = 'fromPlace',
  _TO_PLACE = 'toPlace',
  _LAT = 'lat',
  _LNG = 'lng',
  _LON = 'lon',
  _ZOOM = 'z',
}
